module.exports = __webpack_public_path__ + "static/media/11.b54ff5ce.png";